import { HTMLAttributes } from 'react'

import ScrollIcon from '@/components/base/ScrollIcon'

import { cn } from '@/lib/utils'
import { WPPageData } from '@/types'

export type ScrollingIconProps = HTMLAttributes<HTMLElement> &
  Partial<{
    theme: WPPageData['acf']['hero']['theme']
  }>

const ScrollingIcon = ({
  className,
  theme = 'light',
  ...props
}: ScrollingIconProps) => {
  return (
    <div
      className={cn(['flex items-end gap-[1.6rem] opacity-30', className])}
      {...props}
    >
      <ScrollIcon theme={theme} />
    </div>
  )
}

export default ScrollingIcon
